/* LQK Catch the Dates — slide the basket, catch falling dates, dodge pebbles.
   rAF game loop (pauses when the tab hides). Depends on lqk-games-kit.js */
(function () {
  'use strict';
  var root = document.querySelector('[data-lqkg-arcade]');
  if (!root || !window.LQKG) return;
  var K = window.LQKG;

  var SPRITES = JSON.parse(root.getAttribute('data-sprites'));
  var ROUND_SECS = 60;

  var stage = root.querySelector('[data-stage]');
  var basket = root.querySelector('[data-basket]');
  var cover = root.querySelector('[data-cover]');
  var coverTitle = cover.querySelector('h2');
  var coverText = cover.querySelector('p');
  var startBtn = cover.querySelector('[data-start]');
  var scoreChip = root.querySelector('[data-score]');
  var timeChip = root.querySelector('[data-timeleft]');
  K.soundButton(root.querySelector('[data-sound]'));

  var playing = false;
  var score = 0, timeLeft = ROUND_SECS, elapsed = 0;
  var basketX = 0;      /* center of basket, px in stage coords */
  var items = [];       /* {el, x, y, vy, kind} */
  var raf = null, lastT = 0, spawnAt = 0, clockAt = 0;

  var KINDS = [
    { kind: 'date', weight: 0.78, points: 1, cls: '' },
    { kind: 'gold', weight: 0.12, points: 3, cls: 'lqkg-arc__item--gold' },
    { kind: 'rock', weight: 0.10, points: -1, cls: 'lqkg-arc__item--rock' }
  ];

  function pickKind() {
    var r = Math.random(), acc = 0;
    for (var i = 0; i < KINDS.length; i++) {
      acc += KINDS[i].weight;
      if (r <= acc) return KINDS[i];
    }
    return KINDS[0];
  }

  /* --- basket control: pointer drag anywhere on the stage --- */
  function moveBasket(clientX) {
    var r = stage.getBoundingClientRect();
    var half = basket.offsetWidth / 2;
    basketX = Math.max(half, Math.min(r.width - half, clientX - r.left));
    basket.style.transform = 'translateX(' + (basketX - half) + 'px)';
  }
  stage.addEventListener('pointerdown', function (e) {
    stage.classList.add('is-dragging');
    stage.setPointerCapture(e.pointerId);
    moveBasket(e.clientX);
  });
  stage.addEventListener('pointermove', function (e) {
    if (e.buttons || e.pointerType === 'touch') moveBasket(e.clientX);
  });
  stage.addEventListener('pointerup', function () { stage.classList.remove('is-dragging'); });

  /* --- items --- */
  function spawn() {
    var k = pickKind();
    var el = document.createElement('div');
    el.className = 'lqkg-arc__item ' + k.cls;
    el.innerHTML = '<img src="' + (k.kind === 'rock' ? SPRITES.rock : SPRITES.date) + '" alt="" draggable="false">';
    stage.appendChild(el);
    var w = stage.clientWidth;
    items.push({
      el: el,
      x: 30 + Math.random() * (w - 60),
      y: -60,
      vy: (110 + elapsed * 2.2) * (0.85 + Math.random() * 0.3), /* px per second */
      kind: k
    });
  }

  function floatText(x, y, text, bad) {
    var el = document.createElement('span');
    el.className = 'lqkg-arc__plus' + (bad ? ' lqkg-arc__plus--bad' : '');
    el.textContent = text;
    el.style.left = x - 10 + 'px';
    el.style.top = y + 'px';
    stage.appendChild(el);
    requestAnimationFrame(function () {
      el.style.transform = 'translateY(-42px)';
      el.style.opacity = '0';
    });
    setTimeout(function () { el.remove(); }, 650);
  }

  function catchItem(it) {
    var k = it.kind;
    score = Math.max(0, score + k.points);
    scoreChip.textContent = score;
    basket.classList.remove('is-catch');
    void basket.offsetWidth;
    basket.classList.add('is-catch');
    if (k.points > 0) {
      K.sound.pop();
      K.vibrate(12);
      floatText(it.x, stage.clientHeight - 110, '+' + k.points, false);
    } else {
      K.sound.buzz();
      K.vibrate([30, 40, 30]);
      floatText(it.x, stage.clientHeight - 110, '−1', true);
    }
    it.el.classList.add('is-caught');
    it.el.style.transform += ' scale(1.4)';
    setTimeout(function () { it.el.remove(); }, 220);
  }

  /* --- main loop --- */
  function frame(t) {
    if (!playing) return;
    if (!lastT) lastT = t;
    var dt = Math.min(0.05, (t - lastT) / 1000);
    lastT = t;

    /* spawn cadence speeds up */
    spawnAt -= dt;
    if (spawnAt <= 0) {
      spawn();
      spawnAt = Math.max(0.42, 1.05 - elapsed * 0.009);
    }

    /* clock */
    clockAt += dt;
    if (clockAt >= 1) {
      clockAt -= 1;
      elapsed++;
      timeLeft--;
      timeChip.textContent = timeLeft;
      if (timeLeft <= 0) { end(); return; }
    }

    var H = stage.clientHeight;
    var catchY = H - 84;         /* basket rim */
    var halfW = basket.offsetWidth / 2 - 6;

    for (var i = items.length - 1; i >= 0; i--) {
      var it = items[i];
      it.y += it.vy * dt;
      it.el.style.transform = 'translate(' + (it.x - 26) + 'px,' + it.y + 'px)';
      if (it.y >= catchY && it.y < catchY + 44 && Math.abs(it.x - basketX) <= halfW) {
        catchItem(it);
        items.splice(i, 1);
      } else if (it.y > H + 60) {
        it.el.remove();
        items.splice(i, 1);
      }
    }
    raf = requestAnimationFrame(frame);
  }

  function start() {
    playing = true;
    score = 0; timeLeft = ROUND_SECS; elapsed = 0; lastT = 0; spawnAt = 0; clockAt = 0;
    scoreChip.textContent = '0';
    timeChip.textContent = ROUND_SECS;
    items.forEach(function (it) { it.el.remove(); });
    items = [];
    cover.setAttribute('data-hidden', 'true');
    moveBasket(stage.getBoundingClientRect().left + stage.clientWidth / 2);
    raf = requestAnimationFrame(frame);
  }

  function end() {
    playing = false;
    cancelAnimationFrame(raf);
    items.forEach(function (it) { it.el.remove(); });
    items = [];
    var stars = score >= 30 ? 3 : score >= 18 ? 2 : 1;
    K.sound.win();
    if (stars >= 2) K.confetti();
    coverTitle.textContent = "Time's up!";
    coverText.textContent = 'You collected ' + score + ' date' + (score === 1 ? '' : 's') + '! ' +
      (stars === 3 ? 'Mumtaz — a basket full of barakah!' : stars === 2 ? 'Great catching!' : 'Keep practising!');
    startBtn.textContent = 'Play again';
    cover.setAttribute('data-hidden', 'false');
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden && playing) { cancelAnimationFrame(raf); lastT = 0; }
    else if (!document.hidden && playing) { raf = requestAnimationFrame(frame); }
  });

  startBtn.addEventListener('click', start);
})();
